<div id="reset-password" fxLayout="column" linPerfectScrollbar>
  <div id="reset-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="reset-password-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>

      @if (isMessageShown) {
      <div class="title">{{ 'FORGOT_PASSWORD.TITLE_TEXT' | translate }}?</div>
      <div class="description">{{ 'FORGOT_PASSWORD.DESCRIPTION' | translate }}</div>

      @if (formError) {
      <div class="lin-form-error">{{ formError }}</div>
      }

      <form name="resetForm" [formGroup]="resetForm" (ngSubmit)="resetPassword()" novalidate>
        <mat-form-field>
          <input matInput placeholder="{{ 'FIELDS.EMAIL' | translate }}" formControlName="email" />
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-submit-button [isLoading]="isSubmitting">
          <span>{{ 'FORGOT_PASSWORD.BUTTON_TEXT' | translate }}</span>
        </lin-form-submit-button>
      </form>
      } @else {
      <div class="confirm-message-wrapper">
        <div class="title">{{ 'FORGOT_PASSWORD.LINK_SENT_TITLE' | translate }}</div>
        <div class="confirm-message">
          <p>{{ 'FORGOT_PASSWORD.LINK_SENT_DESCRIPTION' | translate }}</p>
        </div>
      </div>
      }
    </div>
  </div>
</div>
